export const uk = {
    banners: {
        one: '{count} объявления',
        some: '{count} объявлений',
        many: '{count} объявлений',
        none: 'Объявления'
    },
    'banners-loading-failed': 'Не удалось загрузить объявления',
    'go-to-banners': 'Перейти к объявлениям группы',
    'no-banners-available': 'Баннеры для фразы не найдены'
};
